import { useState } from "react";
import { Play } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

/**
 * Plays a call's recording from the timeline. Only shown to people with the call.history permission;
 * the audio is fetched (and checked against the record's access) only when they press play.
 */
export function RecordingPlayer({ callId }: { callId?: string | null }) {
  const { hasPermission } = useAuth();
  const [open, setOpen] = useState(false);
  const [failed, setFailed] = useState(false);
  if (!callId || !hasPermission("call.history")) return null;
  if (!open) {
    return (
      <button type="button" onClick={() => setOpen(true)} className="mt-1 inline-flex w-fit items-center gap-1.5 rounded-md border border-border px-2 py-1 text-xs text-muted-foreground hover:bg-muted hover:text-foreground">
        <Play className="size-3" /> Play recording
      </button>
    );
  }
  if (failed) return <span className="mt-1 text-xs text-muted-foreground">The recording is no longer available.</span>;
  return <audio className="mt-1 h-8 w-full max-w-sm" controls autoPlay preload="auto" src={`/api/Call/Recording/${callId}`} onError={() => setFailed(true)} />;
}
